import { render, staticRenderFns } from "./NewMessageChatSummary.vue?vue&type=template&id=46881016&scoped=true"
import script from "./NewMessageChatSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewMessageChatSummary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewMessageChatSummary.vue?vue&type=style&index=0&id=46881016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46881016",
  null
  
)

export default component.exports